export class Constants {

	public static msgToShowWhileDownloadFile = 'Please deactivate popup blocker';
	public static restrictedConsumerList: number[] = [5101456, 5100696, 5100447, 5100360, 5100340, 5100335, 5100329, 5100304, 5100301, 5100297, 5100273, 5100260, 5100252, 5100476, 5100388, 5100363, 5100354, 5100336, 5100334, 5100324, 5100309, 5100308, 5100305, 5100303, 5100298, 5100291, 5100290, 5100276, 5100266, 5100263, 5100250, 5100249, 5100245, 5100230, 5100216, 5100120, 5100117, 5100115, 5100107, 3100526, 3100255, 3100215, 3100196, 3100195, 3100188, 3100054, 5101409, 5101176, 5100916, 5100897, 5101694, 5101004, 5100876, 5100411, 5100345, 5100325, 3101079, 5100606, 5100352, 5101327];
	// public static rzp_key = 'rzp_test_EsqUrP6MjJQXKy';//development
	public static rzp_key = 'rzp_live_83cUlIrLsn0pr6';//production
	public static limit_for_billdesk_payments = 500000;

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/config/settings/constants.ts